var account = "Konto";
var accountSettings = "Kontoeinstellungen";
var charging = "Aufladen";
var contactInfo = "Kontaktinfo";
var dashboard = "Übersicht";
var home = "Zuhause";
var myProducts = "Meine Produkte";
var orderHistory = "Bestell-Historie";
var paymentMethod = "Zahlungsmethode";
var profileSettings = "Profileinstellungen";
var referAndEarn = "Empfehlen und Verdienen";
var signOut = "Abmelden";
var de_DE = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, de_DE as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
